import React, { Component } from 'react';
import DropDown2 from '../Report/Controls/DropDown2'

import hwconfig from './meters.js'

const unitApiValues = ["Gallons", "KWatt_Hours", "Liters", "Minutes", "ccf", "Cf",
  "kBTU", "m3"];
const display = hwconfig.map(i => i.name)

export default class HwDropdown extends Component {
  constructor(props) {
    super(props);

    this.apiValues = unitApiValues;
    this.state = {
      options: display,
    }
  }
  render () {
    return <DropDown2 {...this.state} {...this.props} value={display}
      onUpdate={(param)=>this.props.onUpdate(hwconfig[param])} />
  }
}

export function UnitsDisplay (apiValue) {
  apiValue = apiValue ?? ''
  const found = unitApiValues.indexOf(apiValue)
  return found < 0 ? (apiValue ? apiValue : "Not Available") : display[found]
}
